import { AlertCircle } from 'lucide-react'

/**
 * Ported from legacy `pages/not-found.tsx`, wording included.
 *
 * The copy is a developer's note in English — "Did you forget to add the page
 * to the router?" — on a page real staff reach whenever they follow one of the
 * twelve sidebar links the router refuses to serve (FRONTEND-BUGS.md FB-001).
 * It is left exactly as it is: rewriting it would hide how often this page is
 * seen, and the honest fix is FB-001, not better wording here.
 *
 * The `data-testid` is what the §12.3 parity harness reads to tell an unported
 * route from a ported one. It used to look for `ScaffoldNotice`, which this
 * component displaced the moment `manager-auth` registered a `notFound` — so
 * every route reported as built, including the two that are not.
 */
export function NotFoundPage() {
  return (
    <div
      data-testid="not-found"
      className="min-h-screen w-full flex items-center justify-center bg-gray-50"
    >
      <div className="w-full max-w-md mx-4 rounded-xl border border-gray-200 bg-white shadow-sm">
        <div className="p-6">
          <div className="flex mb-4 gap-2">
            <AlertCircle className="h-8 w-8 text-red-500" />
            <h1 className="text-2xl font-bold text-gray-900">404 Page Not Found</h1>
          </div>
          <p className="mt-4 text-sm text-gray-600">
            Did you forget to add the page to the router?
          </p>
        </div>
      </div>
    </div>
  )
}
